// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"159":"host-app","566":"bit-app"}[chunkId] + "." + {"159":"9d01887d","566":"5a84e873"}[chunkId] + ".chunk.css";
};